export enum EdsDynamicOverrideMode {
  Replace = 'replace',
  Merge = 'merge',
}
